<template>
  <el-form
    ref="form"
    v-loading="loading"
    :model="form"
    :rules="rules"
    label-width="80px"
    inline
    style="display: flex; flex-direction: column"
  >
    <div>
      <el-form-item label="入库单号">
        <el-input :value="form.fBillNo" readonly />
      </el-form-item>
      <el-form-item label="入库日期">
        <el-date-picker
          v-model="form.fDate"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
          :clearable="false"
        />
      </el-form-item>
      <el-form-item label="入库人">
        <el-select-ex
          v-model="form.fUserID_Rk"
          label-field="fName"
          value-field="fid"
          :sel-first="isNew"
          use-cache
          :extra-param="{ fid: isfid }"
          url="BasicInformation/Employee/StorekeeperEntry"
          style="width: 98%"
        />
      </el-form-item>
      <el-form-item label="仓库">
        <el-select-ex
          v-model="form.fStockID"
          label-field="fName"
          value-field="fStockID"
          :sel-first="isNew"
          :change-confirm="stockChangeConfirm"
          url="Warehouse/Stock/StockEntry"
          style="width: 98%"
        />
      </el-form-item>
      <el-form-item label="交货人">
        <el-select-ex
          v-model="form.fUserID_Jh"
          label-field="fName"
          value-field="fid"
          :sel-first="isNew"
          :extra-param="{ fid: isfid }"
          use-cache
          url="BasicInformation/Employee/StorekeeperEntry"
          style="width: 98%"
        />
      </el-form-item>
      <el-form-item label="质检人">
        <el-select-ex
          v-model="form.fUserID_Zj"
          label-field="fName"
          value-field="fid"
          :sel-first="isNew"
          :extra-param="{ fid: isfid }"
          use-cache
          url="BasicInformation/Employee/StorekeeperEntry"
          style="width: 98%"
        />
      </el-form-item>

      <el-form-item v-if="canEdit && form.state != '已审核'">
        <el-button
          type="primary"
          :disabled="saving"
          @click="submit"
        >保存<span v-if="saving">中...</span></el-button>
        <!-- <el-button @click="refreshNew">新增</el-button> -->
      </el-form-item>
    </div>

    <el-table
      v-el-table-height-fix
      :data="form.entrys"
      style="width: 100%"
      height="100%"
    >
      <el-table-column v-if="canEdit && form.state != '已审核'" width="80">
        <template slot="header">
          <div style="display: flex; align-items: center">
            操作
            <i
              class="el-icon-circle-plus-outline"
              style="
                color: #409eff;
                font-size: 18px;
                margin-left: 5px;
                cursor: pointer;
              "
              title="添加行"
              @click="addRow"
            />
          </div>
        </template>
        <template slot-scope="scope">
          <div class="tools">
            <el-popconfirm title="是否删除？" @confirm="delRow(scope.$index)">
              <i slot="reference" class="el-icon-remove-outline" title="删除" />
            </el-popconfirm>
            <i
              class="el-icon-copy-document"
              title="复制"
              @click="copyRow(scope.$index)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="产品编号"
        label-class-name="font-color-red"
        width="200px"
      >
        <template slot-scope="scope">
          <el-select-table
            v-model="scope.row.ficItemID"
            :label.sync="scope.row.fNumber"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fNumber"
            value-field="ficItemID"
            :extra-param="{ prohibit: true, stockID: form.fStockID }"
            panel-width="500px"
            :clearable="false"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
            @change="fNumberChange(scope.row, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="产品名称" prop="fName" width="250px" />
      <el-table-column label="规格" prop="fModel" width="180px" />
      <el-table-column label="单位" prop="fUnit" width="80px" />
      <el-table-column
        label="数量"
        label-class-name="font-color-red"
        width="120px"
      >
        <template slot-scope="scope">
          <el-input-currency
            v-model="scope.row.fQty"
            :scale="0"
            min="0"
            style="width: 100%"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="批号"
        label-class-name="font-color-red"
        width="150px"
      >
        <template slot-scope="scope">
          <el-input v-model="scope.row.fBatchNo" />
        </template>
      </el-table-column>
      <el-table-column
        label="生产日期"
        label-class-name="font-color-red"
        width="160px"
      >
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.fDate_Sc"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :clearable="false"
          />
        </template>
      </el-table-column>
      <el-table-column label="消毒日期" width="160px">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.fDate_Xd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </template>
      </el-table-column>
      <el-table-column label="追溯号" width="250px">
        <template slot-scope="scope">
          <el-input v-model="scope.row.fRetroactiveNo" />
        </template>
      </el-table-column>
      <el-table-column label="备注" width="250px">
        <template slot-scope="scope">
          <el-input v-model="scope.row.fDes" />
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'

function ClearObj(obj) {
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      obj[key] = null
    }
  }
}

function ClearArr(arr) {
  for (let i = 0; i < arr.length; i++) {
    ClearObj(arr[i])
  }
}

export default {
  components: {},
  data: function() {
    return {
      form: {},
      isfid: this.$route.params.id == 0 ? null : this.$route.params.id,
      rules: {
        // fMinBalance: [{ required: true, message: '必填项', trigger: 'change' }]
      },

      loading: false,
      saving: false,
      isNew: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath
        vm.refresh()
      }
    })
  },
  beforeRouteUpdate: function(to, from, next) {
    next()
    const vm = this
    vm.routePath = to.fullPath
    vm.refresh()
  },
  computed: {
    canEdit: function() {
      const userGrants = this.$store.state.userInfo.userGrants
      // return userGrants.some((x) => x.key == '003001003')
      let grant = null
      let grant2 = null
      let num = null
      userGrants.forEach((val) => {
        if (val.key == '003002002') {
          grant = val.isGrant
        }
        if (val.key == '003002003') {
          grant2 = val.isGrant
        }
      })
      if (grant || grant2) {
        num = true
      } else {
        num = false
      }
      return num
    }
  },
  methods: {
    stockChangeConfirm: async function() {
      var success = await this.$confirm(
        '改变仓库需要重新录入产品明细',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => true)
        .catch(() => false)
      if (success) {
        ClearArr(this.form.entrys)
      }
      return success
    },

    fNumberChange: function(item, item2) {
      item.fName = item2 ? item2.fName : null
      item.fModel = item2 ? item2.fModel : null
      item.fUnit = item2 ? item2.fUnit : null
    },

    submit: async function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true
          this.$httpPost('Warehouse/ProductStock/ProductStockModify', {
            datalist: JSON.stringify({
              modifyType: this.isNew ? 0 : 1,
              info: this.form
            })
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message)
                return
              }

              // 重新刷新页面数据
              this.$message.success(res.message)
              this.refresh(res.datalist)
            })
            .finally(() => (this.saving = false))
        } else {
          return false
        }
      })
    },

    addRow: function() {
      const entrys = this.form.entrys
      entrys.push({
        ficItemID: null,
        fNumber: null,
        fName: null,
        fModel: null,
        fUnit: null,
        fQty: null,
        fBatchNo: null,
        fDate_Sc: null,
        fDate_Xd: null,
        fRetroactiveNo: null,
        fDes: null
      })
    },
    delRow: function(index) {
      const entrys = this.form.entrys
      entrys.splice(index, 1)
    },
    copyRow: function(index) {
      const entrys = this.form.entrys
      const maxEntryId = entrys.length
        ? Math.max.apply(
          null,
          entrys.map((x) => x.fEntryID)
        )
        : 0
      const copy = DeepCopy(entrys[index])
      copy.fEntryID = maxEntryId + 1
      entrys.splice(index, 0, copy)
    },

    refresh: async function(fid) {
      const id = fid || +this.$route.params.id
      this.isNew = !id
      // console.log(this.$route.params.id, 'this.$route.params.id')
      if (this.$route.params.id !== 0) {
        this.isfid = this.$route.params.id
      }
      if (id == 0) {
        this.form = {
          fid: null,
          fBillNo: null,
          fCreateTime: Now(),
          fDate: Today(),
          fUserID_Rk: null,
          fStockID: null,
          fUserID_Jh: null,
          fUserID_Zj: null,
          entrys: []
        }
        // 保证页面至少有10行
        for (let i = 0; i < 10; i++) {
          this.addRow()
        }

        return
      }

      this.loading = true
      const res = await this.$httpPost(
        'Warehouse/ProductStock/GetProductStock',
        {
          fid: id
        }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }

      this.form = res.datalist

      const entrys = this.form.entrys

      // 保证页面至少有10行
      const rowsToAdd = 10 - entrys.length
      for (let i = 0; i < rowsToAdd; i++) {
        this.addRow()
      }
    },
    refreshNew: function() {
      const id = +this.$route.params.id
      if (id == 0) {
        this.refresh()
        return
      }
      this.$router.push('./0')
    }
  }
}
</script>

<style lang="less" scoped>
.tools i {
  margin-right: 5px;
  cursor: pointer;
  color: #409eff;
  font-size: 18px;
}
</style>
